export const getProjectName = (isTemplate) =>
  `${
    isTemplate ? 'New Template' : 'New Project'
  } ${new Date().toLocaleDateString(undefined, {
    month: 'long',
    day: 'numeric',
  })}`;
